import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "App-M-Footer" }
const _hoisted_2 = {
  key: 0,
  class: "App-M-Footer-B-H"
}
const _hoisted_3 = { class: "App-M-Footer-M-H" }
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { class: "App-M-Footer-Menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterBanner = _resolveComponent("FooterBanner")!
  const _component_app_logo = _resolveComponent("app-logo")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FooterBanner)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_space, {
          direction: "vertical",
          size: 12
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_app_logo, { size: 40 })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_space, {
                  style: {"justify-content":"center"},
                  alignment: "center",
                  wrap: "",
                  size: 16
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `menu-link${link.url}`
                      }, [
                        _createVNode(_component_router_link, {
                          class: "App-M-Footer-Link",
                          to: link.url
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider),
      _createElementVNode("div", null, [
        _createVNode(_component_app_footer, {
          openExternal: false,
          size: "large"
        })
      ])
    ])
  ]))
}